import { createAction } from 'redux-actions';
import Axios from 'axios';
import { getPtpPagos } from 'src/services/urls';
export const fetchingCotizacion = createAction('FETCHING_COTIZACION');
export const setCotizacion = createAction('SET_COTIZACION');

export const setCotizacionConfig = (data) => async (dispatch, getState) => {
  let data2 = { ...data?.cotizacion };
  console.log("SET_COTIZACION_CONFIG: ", data2);
  let id = data2?.idCotizacion;

  let empresa = '';
  if (data2?.configuracion?.credencialesPtp?.empCodigo) {
    empresa = data2?.configuracion?.credencialesPtp.empCodigo;
  } else {
    switch (data2?.flujoPlugin) {
      case '6':
        break;
      case '7':
      case '9':
        empresa = data2?.producto?.codigoCore;
        break;
      case '10':
        break;
      default:
        empresa = data2?.empPtp;
        break;
    }
  }
  try {
    const url = `${getPtpPagos(id, empresa)}`;
    const res = await Axios.get(url);
    if (res.statusText === 'OK') {
      if (res.data?.transaccion) {
        data2.historialPago = res.data?.data ?? [];
      }
    }
  } catch (error) {
    console.log('error consultando pago');
  }
  await dispatch(setCotizacion(data2));
};
/*
    PRODUCTOS (HOME)
*/
export const fetchingProductos = createAction('FETCHING_PRODUCTOS');
export const setProductos = createAction('SET_PRODUCTOS');

export const setBeneficiarioIgualTitularAction = createAction('SET_TITULAR_IGUAL_BENEFICIARIO');

/*
=================================================================================
                                INGRESAR POLIZA
=================================================================================
*/

/*
  GENERACION DE TOKENS PARA TRANSFERENCIAS Y FIRMA DE POLIZAS,
  FLUJO 4
  ESTE FLUJO ES PARA LAS ENTIDADES INTERNAS 29octubre, mazuay,etc
*/
export const getToken = createAction('FETCTHING_GET_TOKEN');
export const dataGetToken = createAction('DATA_GET_TOKEN');

export const asyncGetTokenCot = () => (dispatch, getState) => {
  //   dispatch(getToken({ loading: true, completed: false }));
  //   const onComplete = ({ data }) => {
  //     const payload = {
  //       transaccion: data.transaccion,
  //     };
  //     if (!data.transaccion) {
  //       payload.mensaje = 'Ups. Algo ha salido mal.';
  //       guardarLog(data);
  //     }
  //     dispatch(dataGetToken(payload));
  //   };
  //   const URL = `${URL_PLUGIN_PROD}get-token-cotizacion`;
  //   const { cotizacion } = getState()['Cotizacion'];
  //   const { idCotizacion } = cotizacion;
  //   const body = {
  //     idCotizacion: idCotizacion,
  //   };
  //   // return POST({
  //   //   url: URL,
  //   //   body,
  //   //   ...dispatcher(getToken, onComplete),
  //   // });
};

/*
  VERIFICACION DE TOKENS PARA TRANSFERENCIAS Y FIRMA DE POLIZAS,
  FLUJO 4
  ESTE FLUJO ES PARA LAS ENTIDADES INTERNAS 29octubre, mazuay,etc
*/

export const verificarToken = createAction('FETCHING_VERIFICAR_TOKEN');
export const dataVerificarToken = createAction('DATA_VERIFICAR_TOKEN');

export const asyncVerificarTokenCot = (token) => (dispatch, getState) => {
  // dispatch(verificarToken({ loading: true, completed: false }));
  // const onComplete = ({ data }) => {
  //   const payload = {
  //     transaccion: data.transaccion,
  //   };
  //   if (!data.transaccion) {
  //     payload.mensaje = 'El token ingresado es incorrecto intenta nuevamente.';
  //     guardarLog(data);
  //   }
  //   dispatch(dataVerificarToken(payload));
  //   //if (callback) callback(response.data);
  // };
  // const URL = `${URL_PLUGIN_PROD}verificar-token-cotizacion`;
  // const { cotizacion } = getState()['Cotizacion'];
  // const { idCotizacion, infoTransaccion } = cotizacion;
  // const body = {
  //   ip: miIp,
  //   idCotizacion: idCotizacion,
  //   numCuentaOrigen: infoTransaccion.numCuentas[0].num,
  //   token: token,
  // };
  // return POST({
  //   url: URL,
  //   body,
  //   ...dispatcher(verificarToken, onComplete),
  // });
};
